'use strict';

var scroll = {
	header: {
		active: false,
		init: function init() {
			if ($('.header .header-inner').length > 0) {
				scroll.header.active = true;
				scroll.header.getItems();
			}
		},
		getItems: function getItems() {
			if (scroll.header.active) {
				scroll.header.items = {
					$this: $('.header .header-inner'),
					t: 50,
					changed: false,
					sticky: false
				};
			}
		},
		calculation: function calculation(pos) {
			var items = scroll.header.items;
			if (scroll.header.active) {
				if (pos.current.top == 0) {
					scroll.header.changed = false;
				} else if (pos.current.top >= items.t) {
					scroll.header.changed = true;
					scroll.header.sticky = true;
				} else {
					scroll.header.changed = false;
				}
			}
		},
		animation: function animation() {
			var items = scroll.header.items;
			if (scroll.header.active) {
				if (scroll.header.changed) {
					if (scroll.header.sticky) {
						items.$this.addClass('active');
					} else {
						items.$this.removeClass('active');
					}
				} else {
					items.$this.removeClass('active');
				}
			}
		},
		resize: function resize() {
			// ...
		}
	}
};